import { render, staticRenderFns } from "./Homologaciones.vue?vue&type=template&id=82986b60"
import script from "./Homologaciones.vue?vue&type=script&lang=js"
export * from "./Homologaciones.vue?vue&type=script&lang=js"
import style0 from "./Homologaciones.vue?vue&type=style&index=0&id=82986b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports